import { render, staticRenderFns } from "./TwentyFourHours.vue?vue&type=template&id=29c1e26a"
import script from "./TwentyFourHours.vue?vue&type=script&lang=js"
export * from "./TwentyFourHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports